import React, { useMemo, useState } from 'react';
import { BlockWrapper, defineBlock } from '@smartfire/js-block-engine';
import { useMediaQuery } from '@mui/material';
import { ReactComponent as Cross } from './assets/cross.svg';
import clsx from 'clsx';
import style from './block.module.scss';

// Emojis
import { ReactComponent as Bell } from './assets/fi-rs-bell.svg';
import { ReactComponent as Gift } from './assets/fi-rs-gift.svg';
import { ReactComponent as Heart } from './assets/fi-rs-heart.svg';
import { ReactComponent as Info } from './assets/fi-rs-info.svg';
import { ReactComponent as Smiley } from './assets/fi-rs-laugh.svg';
import { ReactComponent as Exclamation } from './assets/fi-rs-shield-exclamation.svg';
import { ReactComponent as Interrogation } from './assets/fi-rs-shield-interrogation.svg';
import { ReactComponent as Ticket } from './assets/fi-rs-ticket.svg';
import { ReactComponent as Clock } from './assets/fi-rs-time-quarter-past.svg';
import { ReactComponent as Trophy } from './assets/fi-rs-trophy.svg';

const CSS_COLORS = {
    green: {
        backgroundColor: style.green,
        primaryColor: style.blue,
        closeButtonColor: style.blue,
    },
    blue: {
        backgroundColor: style.darkBlue,
        primaryColor: style.white,
        closeButtonColor: style.white,
    },
    light_blue: {
        backgroundColor: style.blue6,
        primaryColor: style.black,
        closeButtonColor: style.black,
    },
};

const emojis = {
    bell: Bell,
    gift: Gift,
    heart: Heart,
    info: Info,
    smiley: Smiley,
    exclamation: Exclamation,
    interrogation: Interrogation,
    ticket: Ticket,
    clock: Clock,
    trophy: Trophy,
};

const Banner = ({ bannerId, content, emoji, backgroundColor, link, linkInText }) => {
    const [isHidden, setIsHidden] = useState(false);
    const isMobile = useMediaQuery(`(max-width: ${style.mobileBreakpoint})`);
    const EmojiIcon = useMemo(() => emojis[emoji] || null, [emoji]);

    const bannerStyles = {
        '--smartfire-banner-background-color': CSS_COLORS[backgroundColor].backgroundColor,
        '--smartfire-banner-primary-color': CSS_COLORS[backgroundColor].primaryColor,
        '--smartfire-banner-close-button-color': CSS_COLORS[backgroundColor].closeButtonColor,
    };

    const linkProps = {
        href: link?.url,
        target: link.target || '_self',
        rel: link.target === '_blank' ? 'noopener noreferrer' : undefined,
    };

    const setSessionCookie = (name, value) => {
        document.cookie = `${name}=${value};path=/`;
    };

    const handleClose = () => {
        setIsHidden(true);
        setSessionCookie(`banner-closed-${bannerId}`, 'true');
    };

    const LinkDistached = () => (
        <a className={style.linkDetached} {...linkProps}>
            {link?.title}
        </a>
    );

    return (
        <BlockWrapper.Div
            className={clsx(style.banner, isHidden && style.hide, isMobile && style.mobile)}
            style={bannerStyles}
        >
            <div className={style.container}>
                <div className={style.start}>
                    {EmojiIcon && <EmojiIcon className={style.emoji} />}

                    <div className={style.content}>
                        <p>
                            {content}
                            {linkInText && link?.url && <a {...linkProps}>{link?.title}</a>}
                        </p>

                        {isMobile && !linkInText && link?.url && (
                            <div className={style.linkContainer}>
                                <LinkDistached />
                            </div>
                        )}
                    </div>
                </div>

                <div className={style.end}>
                    {!isMobile && !linkInText && link?.url && <LinkDistached />}
                    <Cross className={style.closeButton} onClick={handleClose} />
                </div>
            </div>
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block: Banner,
});
